/* Domovoi · where this code is running.

   The only module that may ask about Capacitor. Screens ask here, never
   window.Capacitor directly, so the web build carries no native assumptions. */

/* The commit this bundle was built from (first 7 characters), stamped at build
   time. 'local' for a build on a laptop. */
export const BUNDLE_SHA = typeof __BUNDLE_SHA__ !== 'undefined' ? __BUNDLE_SHA__ : 'local';

/* 'web' | 'ios' | 'android' */
export function platform() {
  var C = typeof window !== 'undefined' && window.Capacitor;
  return C && typeof C.getPlatform === 'function' ? C.getPlatform() : 'web';
}

export function isNative() { return platform() !== 'web'; }

/* The colour of the status bar's text (time, battery) in the app: 'light' over
   a dark bar (the site nav on the account and sign-in pages), 'dark' over the
   shell's milk header. The app draws the page under the status bar, and the
   setting outlives the page, so every page sets its own. */
export function statusBarText(tone) {
  try {
    var sb = isNative() && window.Capacitor.Plugins && window.Capacitor.Plugins.StatusBar;
    if (sb) sb.setStyle({ style: tone === 'light' ? 'DARK' : 'LIGHT' });   // Capacitor names the background, not the text
  } catch (e) { /* not worth failing a page over */ }
}

/* The native shell's version, once the shell sets it (Phase 2). Null on the web. */
export function shellVersion() {
  return (typeof window !== 'undefined' && window.DVShell && window.DVShell.version) || null;
}

/* Which native capabilities this shell has, e.g. hasNative('push'). Always false on the web. */
export function hasNative(capability) {
  var s = typeof window !== 'undefined' && window.DVShell;
  return !!(s && s.capabilities && s.capabilities.indexOf(capability) !== -1);
}

/* Production web hosts. Previews and local builds keep analytics off. */
export function isProductionHost() {
  var h = location.hostname;
  return h === 'domovoi.ca' || h === 'domovoi.app';
}

/* Inside the app, Capacitor's local server answers a folder address (/signin/)
   with the app's own index.html — the shell — so a page there must be asked
   for by file (/signin/index.html). On the web this returns the path as is. */
export function pageUrl(path) {
  if (!isNative()) return path;
  var m = /^(\/[^?#]*\/)([?#].*)?$/.exec(path || '');
  return m && m[1] !== '/' ? m[1] + 'index.html' + (m[2] || '') : path;
}
